import { useEffect, useState } from 'react';

import { useResponsive } from '@depop/web-ui-kit/useResponsive';

import { getActiveFiltersCount } from '@/modules/search/helpers';
import { useSearchFilters } from '@/modules/search/useSearchFilters';
import { useFilteredShopProducts } from '@/modules/shop/hooks/useFilteredShopProducts';
import { useIsViewingOwnShop } from '@/modules/shop/hooks/useIsViewingOwnShop';

export function useShopFilters(sellerId?: number) {
  const { isMaxSmall: isMobile } = useResponsive();
  const { searchFilters } = useSearchFilters();
  const productsQuery = useFilteredShopProducts(sellerId);
  const isViewingOwnShop = useIsViewingOwnShop();

  const [hasProductsOnPageLoad, setHasProductsOnPageLoad] = useState(false);

  const hasActiveFilters = getActiveFiltersCount(searchFilters) > 0;
  const initialPageLength =
    productsQuery.data?.pages?.[0].data?.objects?.length || 0;

  useEffect(() => {
    if (initialPageLength > 0 && !hasProductsOnPageLoad) {
      setHasProductsOnPageLoad(true);
    }
  }, [initialPageLength, hasProductsOnPageLoad]);

  const showFilters =
    !isViewingOwnShop && (hasProductsOnPageLoad || hasActiveFilters);

  return {
    showMobileFilters: showFilters && isMobile,
    showDesktopFilters: showFilters && !isMobile,
    hasActiveFilters,
  };
}
